import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";
import { useParams } from "react-router";

import { Module } from "@modules/agreements/types";
import { ApiError } from "@shared/types";
import { ModuleFormValues } from "@modules/agreements/validations";
import { createModuleService } from "./service";
import { UseCreateModuleMutationOptions } from "./types";
import requestErrorTreatment from "@shared/utils/requestErrorTreatment";

export function useCreateModuleMutation(
  options?: UseCreateModuleMutationOptions
) {
  const translate = useTranslate();
  const { open } = useNotification();

  const { id: agreement } = useParams();

  return useMutation<Module, ApiError, ModuleFormValues>({
    mutationFn: (data) => createModuleService({ ...data, agreement }),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("module_admin.success.create"),
      });
    },
    onError: (error: ApiError) => {
      requestErrorTreatment(error, open);
    },
    ...options,
  });
}
